
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { FormState__setValidationResponse_5219762A, FormState__startLoading, FormState_get_empty, FormState_$reflection, NoticeId_$reflection, ToolId_$reflection, ClientApiResponse$1_$reflection, PostResponse$1_$reflection, EmptyResponse_$reflection } from "../../Shared/Shared.js";
import { record_type, lambda_type, unit_type, union_type, class_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_deleteNoticeCmd } from "../../Requests/Tool.js";
import { Cmd_errorToast } from "../../Components/Toast.js";
import { ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { ConfirmationDialog } from "../../Components/Dialog.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DeleteNotice", "NoticeDeletedResponse", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Tools.ToolDeleteNoticeDialog.Msg", [], Msg, () => [[], [["Item", ClientApiResponse$1_$reflection(PostResponse$1_$reflection(EmptyResponse_$reflection()))]], [["Item", class_type("System.Exception")]]]);
}

class State extends Record {
    constructor(ToolId, NoticeId, FormState, SuccessCallback, OnClose) {
        super();
        this.ToolId = ToolId;
        this.NoticeId = NoticeId;
        this.FormState = FormState;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
    }
}

function State_$reflection() {
    return record_type("Tools.ToolDeleteNoticeDialog.State", [], State, () => [["ToolId", ToolId_$reflection()], ["NoticeId", NoticeId_$reflection()], ["FormState", FormState_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)]]);
}

function init(noticeId, toolId, successCallback, onClose) {
    return [new State(toolId, noticeId, FormState_get_empty(), successCallback, onClose), Cmd_none()];
}

function update(msg, state) {
    switch (msg.tag) {
        case 0:
            return [new State(state.ToolId, state.NoticeId, FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose), Cmd_deleteNoticeCmd(state.ToolId, state.NoticeId, (Item) => (new Msg(1, [Item])), (Item_1) => (new Msg(2, [Item_1])))];
        case 2:
            return [new State(state.ToolId, state.NoticeId, FormState_get_empty(), state.SuccessCallback, state.OnClose), Cmd_errorToast("general.a_error_occured")];
        default:
            if (msg.fields[0].tag === 1) {
                return [new State(state.ToolId, state.NoticeId, FormState__setValidationResponse_5219762A(state.FormState, msg.fields[0].fields[0]), state.SuccessCallback, state.OnClose), Cmd_none()];
            }
            else {
                return [new State(state.ToolId, state.NoticeId, FormState_get_empty(), state.SuccessCallback, state.OnClose), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                })]))];
            }
    }
}

export function OpenNoticeDeleteDialog(props) {
    let Title;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.NoticeId, props.ToolId, props.SuccessCallback, props.OnClose), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    return createElement(ConfirmationDialog, (Title = t("general.delete"), {
        Description: t("notice.delete_notice_query"),
        FormState: state_1.FormState,
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        OnConfirm: state_1.FormState.IsLoading ? (() => {
        }) : (() => {
            patternInput_1[1](new Msg(0, []));
        }),
        Title: Title,
    }));
}

